import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import notify from 'devextreme/ui/notify';
import { OrderFacade } from 'src/app/store/order/facade';
import { ProblemForUserFacade } from 'src/app/store/problem-user/facade';
import { ProblemFacade } from 'src/app/store/problem/facade';
import { UrgencyFacade } from 'src/app/store/urgency/facade';
import { UserFacade } from 'src/app/store/user/facade';
import { SearchServiceFacade } from '../../../store/self-diagnostic/search-service/facade';
import { SelfDiagnosisFacade } from '../../../store/self-diagnostic/self-diagnosis/facade';
import { SelfDiagnosticStepFacade } from '../../../store/self-diagnostic/self-diagnostic-step/facade';
import { ServiceCatalogFacade } from '../../../store/self-diagnostic/service-catalog/facade';
import { TopServiceFacade } from '../../../store/self-diagnostic/top-service/facade';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: false,
})
export class MessageComponent implements OnInit {
  private userFacade = inject(UserFacade);
  private orderFacade = inject(OrderFacade);
  private problemFacade = inject(ProblemFacade);
  private problemForUserFacade = inject(ProblemForUserFacade);
  private searchServiceFacade = inject(SearchServiceFacade);
  private selfDiagnosisFacade = inject(SelfDiagnosisFacade);
  private selfDiagnosticStepFacade = inject(SelfDiagnosticStepFacade);
  private urgencyFacade = inject(UrgencyFacade);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private topServiceFacade = inject(TopServiceFacade);
  private translate = inject(TranslateService);

  public ngOnInit(): void {
    this.userFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.orderFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.problemFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.problemForUserFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.searchServiceFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.selfDiagnosisFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.selfDiagnosticStepFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.urgencyFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.serviceCatalogFacade.getError().subscribe(e => {
      this.showError(e);
    });

    this.topServiceFacade.getError().subscribe(e => {
      this.showError(e);
    });
  }

  private async showError(e: any) {
    if (e) {
      console.error('error', e);

      if (e instanceof HttpErrorResponse && e.status == 401) {
        return;
      } else if (e == 'ORDER_NOT_FOUND') {
        let message = await this.translate.get(e).toPromise();
        notify({ message: message, width: 600 }, 'error', 5000);
      } else if (typeof e === 'string' && (<string>e).startsWith('Corezoid')) {
        let message = await this.translate.get(e).toPromise();
        notify({ message: message, width: 600 }, 'error', 5000);
      } else if (typeof e === 'string') {
        console.error('error', e);
        notify({ message: e, width: 600 }, 'error', 5000);
      } else {
        notify({ message: e.message, width: 600 }, 'error', 5000);
      }
    }
  }
}
